import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

// Event types for invoice-related operations
// These can be expanded as needed
export enum InvoiceEventType {
    INVOICE_UPDATED = 'INVOICE_UPDATED',
    ESTIMATE_PUBLISHED = 'ESTIMATE_PUBLISHED'
}

// Interface for invoice event data
export interface InvoiceEventData {
    type: InvoiceEventType;
    invoiceId?: string;
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceEventService {
    private eventSubject = new Subject<InvoiceEventData>();

    public events$: Observable<InvoiceEventData> = this.eventSubject.asObservable();

    emitEvent(eventData: Partial<InvoiceEventData>): void {
        const completeEventData: InvoiceEventData = {
            ...eventData
        } as InvoiceEventData;

        this.eventSubject.next(completeEventData);
    }

    onAccountBalanceUpdated(): Observable<InvoiceEventData> {
        return this.events$.pipe(
            filter(event => event.type === InvoiceEventType.INVOICE_UPDATED || event.type === InvoiceEventType.ESTIMATE_PUBLISHED)
        );
    }

    onInvoiceUpdated(invoiceId: string): Observable<InvoiceEventData> {
        return this.events$.pipe(
            filter(event => event.type === InvoiceEventType.INVOICE_UPDATED && event.invoiceId === invoiceId)
        );
    }

    onEstimatePublished(): Observable<InvoiceEventData> {
        return this.events$.pipe(
            filter(event => event.type === InvoiceEventType.ESTIMATE_PUBLISHED)
        );
    }

    itemsUpdated(invoiceId: string): void {
        this.emitEvent({
            type: InvoiceEventType.INVOICE_UPDATED,
            invoiceId
        });
    }

    estimatePublished(newInvoiceId: string): void {
        this.emitEvent({
            type: InvoiceEventType.ESTIMATE_PUBLISHED,
            invoiceId: newInvoiceId
        });
    }
}